export default class SwiperSettings {

  static params = {
    carousel: {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      spaceBetween: 20,
      slidesPerView: 6,
      freeMode: true,
      speed: 200,
      breakpoints: {
        300: {
          slidesPerView: 2,
          spaceBetween: 10,

        },
        768: {
          spaceBetween: 20,
          slidesPerView: 4,
        },
        1280: {
          spaceBetween: 20,
          slidesPerView: 6,
        }
      }
    },
    carouselAlt: {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      spaceBetween: 20,
      slidesPerView: 4,
      freeMode: true,
      speed: 200,
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 10,
          freeMode: false,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 2,
          freeMode: false,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 4,
          freeMode: true,
        }
      }
    },
    carouselAlt2reverse: {
      spaceBetween: 20,
      slidesPerView: 3.2,
      freeMode: true,
      speed: 200, 
      breakpoints: {
        300: {
          slidesPerView: 2.1,
          spaceBetween: 10,
          freeMode: false,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 2,
          freeMode: false,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 3.2,
          freeMode: true,
        }
      }
    },
    carouselAlt2: {
      spaceBetween: 20,
      slidesPerView: 3.2,
      freeMode: true,
      speed: 200,
      breakpoints: {
        300: {
          slidesPerView: 2.1,
          spaceBetween: 10,
          freeMode: false,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 2,
          freeMode: false,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 3.2,
          freeMode: true,
        }
      }
    },
    frames: {
      slidesPerView: 'auto',
      spaceBetween: 96,
      effect: 'coverflow',
      centerInsufficientSlides: true,
      slideToClickedSlide: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      loop: true,
      speed: 800,
      breakpoints: {
        300: {
          spaceBetween: 24,
        },
        1024: {
          spaceBetween: 96,
        }
      },
    },
    tabsControls: {
      speed: 400,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 20,
      centerInsufficientSlides: true,
      slideToClickedSlide: true,
      allowTouchMove: false,
      breakpoints: {
        1024: {
          centeredSlides: false,
          spaceBetween: 20,
        }
      },
    },
    lightbox: {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: "fraction",
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      parallax: true,
      speed: 1200,
      loop: false,
      slidesPerView: 1,
      spaceBetween: 60,
      centeredSlides: true,
    },
    details: {
      spaceBetween: 20,
      slidesPerView: 6,
      freeMode: true,
      speed: 200,
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 5,

        },
        300: {
          slidesPerView: 3,
          spaceBetween: 10,

        },
        1025: {
          spaceBetween: 20,
          slidesPerView: 4,
        },
        1400: {
          spaceBetween: 40,
          slidesPerView: 6,
        }
      }
    },
    controls: {
      speed: 1200,
      direction: 'vertical',
      slidesPerView: 4,
      spaceBetween: 6,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    },
    slider: {
      speed: 1200,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      slidesPerView: 2,
      spaceBetween: 10,
      breakpoints: {
        300: {
          slidesPerView: 1.5,
          spaceBetween: 10,
          freeMode: true,
          speed: 200,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 2.5,
          freeMode: false,
          speed: 1200,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 1,
          freeMode: false,
          speed: 1200,
        },
      },
    },
    coverControls: {
      speed: 1200,
      direction: 'vertical',
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      allowTouchMove: false,
      effect: "creative",
      creativeEffect: {
        prev: {
          translate: [0, "-100%", 0],
        },
        next: {
          translate: [0, "100%", 0],
        },
      },
    },
    coverSlider: {
      speed: 1200,
      spaceBetween: 0,
      direction: 'vertical',
      slidesPerView: 1,
      allowTouchMove: false,
      effect: "fade"
    }
  }

  static features = {
    carousel: {
      navCheck: true
    },
    carouselAlt: {
      navCheck: true
    },
    carouselAlt2: {
      navCheck: true,
      outsideControls: true
    },
    carouselAlt2reverse: {
      navCheck: true,
      outsideControls: true
    },
    frames: {
      tabs: true,
      node: 'tabsControls'
    },
    tabsControls: {},
    lightbox: {
      captions: true,
      initSlide: true
    },
    details: {},
    slider: {
      thumbs: true,
      node: 'controls'
    },
    controls: {},
    coverSlider: {
      customPagination: true,
      thumbs: true,
      node: 'coverControls'
    },
    coverControls: {}
  }

  static getParams(key) {
    return Object.assign({}, this.params[key]);
  }

  static getFeatures(key) {
    return this.features[key];
  }

  static get(key) {
    return {
      params: this.getParams(key),
      features: this.getFeatures(key),
    }
  }
}
